import type { History } from 'history';
import { type ReactNode, useLayoutEffect, useState } from 'react';
import { Router } from 'react-router-dom';

type BrowserRouterProps = {
  basename?: string;
  children?: ReactNode;
  history: History;
};

const HistoryRouter = ({ basename, children, history }: BrowserRouterProps) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router
      basename={basename}
      children={children}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    />
  );
};

export default HistoryRouter;
